import Typography from "typography"
import Wordpress2016 from "typography-theme-wordpress-2016"

Wordpress2016.overrideThemeStyles = () => {
  return { 
    "html":{
      baseFontSize:`18px`,
      fontFamily:`Montserrat`,
      background:`#f5f7f6`,
      color:'white',
      fontWeight:200,
    },
    'blockquote': {
       border:`none`,
       marginLeft:"10px"
    },
    "a.gatsby-resp-image-link": {
      boxShadow: `none`,
      textDecoration:`none`
    },
    "a.gatsby-resp-image-link:hover": {
      boxShadow: `none`,
      textDecoration:`none`,
      color:`white`
    },
    "a": {
      textDecoration:`none`,
      color:`white`
    },
   
   "h1,h2,h3,h4":{
    fontWeight:`200`,
    color:`white`,
    fontFamily: `Montserrat`
    
  },
  "h1": {
    fontSize: `1.3rem`,
    textTransform: `uppercase`
  },
  "h2": {
    fontSize: `1.2rem`,
    textTransform: `uppercase`
  },
  "h3": {
    fontSize: `1.1rem`,
    textTransform: `uppercase`
  },
  "p": {
    fontSize: `1rem`,
    fontWeight:'200',
    color:`white`
  }
  

  }
}

delete Wordpress2016.googleFonts

const typography = new Typography(Wordpress2016)

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
